import { TRANSPORT_BASE_URL } from '@/helpers/constants';

export default {
	namespaced: true,

	state: {},

	actions: {
		fetchBusInfo({ rootState }) {
			return window.axios
				.get(
					`${TRANSPORT_BASE_URL}/center/${rootState.login.activeUser.centerId}/students/${rootState.login.activeUser.userName}/get-bus`,
				)
				.then((res) => {
					return res.data;
				});
		},

		fetchPoints({ rootState }) {
			return window.axios
				.get(
					`${TRANSPORT_BASE_URL}/center/${rootState.login.activeUser.centerId}/students/${rootState.login.activeUser.userName}/get-points`,
				)
				.then((res) => {
					return res.data;
				});
		},

		fetchPointsByAssistant({ rootState }, { busId }) {
			return window.axios
				.get(
					`${TRANSPORT_BASE_URL}/center/${rootState.login.activeUser.centerId}/students/${rootState.login.activeUser.userName}/bus-coordinates`,
					{ params: { busId } }
				)
				.then((res) => {
					return res.data;
				});
		},

		fetchStatus({ rootState }) {
			return window.axios
				.get(
					`${TRANSPORT_BASE_URL}/center/${rootState.login.activeUser.centerId}/students/${rootState.login.activeUser.userName}/get-status`,
				)
				.then((res) => {
					return res.data;
				});
		},
	},
};
